export var dataHooks;
(function (dataHooks) {
    dataHooks["track"] = "track";
    dataHooks["knob"] = "knob";
    dataHooks["knobIcon"] = "knob-icon";
    dataHooks["toggleSwitchInput"] = "toggle-switch-input";
})(dataHooks || (dataHooks = {}));
//# sourceMappingURL=constants.js.map